export function isDateValid(dateString) {
  const inputDate = new Date(dateString);
  const currentDate = new Date();

  // Normalize dates to remove time components
  inputDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  // Calculate the difference in days
  const timeDifference = inputDate - currentDate;
  const dayDifference = timeDifference / (1000 * 60 * 60 * 24);

  // Return false if the date is more than 2 days in the future
  if (dayDifference > 2) {
    return false;
  }

  // Return true if the date is today, in the past, or within the next 2 days
  return dayDifference <= 2;
}
